import {SET_POPUP_OPEN,
    CREATE_POPUP_MATRIX,
    SET_POPUP_MATRIX_STATUS, 
    RESET_POPUP_MATRIX  } from '../actions/actionTypes'

const initState = {
    popupStatus : false,
    cellId : "",
    type : "",
    popupConfig : {},
    clickedOn : 0
}

const popupStatusReducer = (state = initState, action) => {
    // , JSON.stringify(action)
    // console.log(action.info)
    switch(action.type){
        case SET_POPUP_OPEN : return {
            ...state,
            popupStatus : action.popupStatus
        }
        case SET_POPUP_MATRIX_STATUS : 
            return {
                ...state,
                popupStatus : true,
                cellId : action.id,
                type : action.sigReport,
                popupConfig : action.newStatus,
                clickedOn : Date.now()
            }
        case RESET_POPUP_MATRIX : 
            return {
                ...state,
                popupStatus  : false,
                cellId : "",
                type : "",
                popupConfig : {},
                clickedOn : 0
            }
        default : return state
    }
};

export default popupStatusReducer;